import React from "react";
import "./FooterMainPage.css";
import logo_bank_for_business from "~/assets/mainPage/footer/Logo_BankForBusiness.svg";

const Footer = () => {
    return (
        <footer className={"main-page-footer"}>
            <img
                src={logo_bank_for_business}
                alt='bank_for_business'
                className="bank_for_business-logo"
            />
            <p className={"main-page-footer-phone"}>0-800-50-44-50</p>
        </footer>
    );
};

export default Footer;